import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ReactComponent as DiamondIcon } from "../../assets/images/diamond-icon.svg";
import { selectUser } from "../../core/auth/authSlice";
import Button from "../essentials/button/Button";

interface SubscribeButtonProps {
	onNavigate?: () => void;
}

function SubscribeButton({ onNavigate }: SubscribeButtonProps) {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const user = useSelector(selectUser);

	const handleSubscribe = () => {
		navigate("/subscription");
		onNavigate?.();
	};

	const buttonText =
		user?.accountLevel === "premium" ? "Upgrade" : t("sideMenu.upgradePremium");

	return (
		<Button
			className="btn btn-link side-menu__navigation-btn side-menu__navigation-btn-premium"
			action={handleSubscribe}
			disabled
		>
			{<DiamondIcon className="side-menu__navigation-btn-icon" />}
			{buttonText}
		</Button>
	);
}

export default SubscribeButton;
